//# sourceMappingURL=weaviate.mjs.map
/// <reference types="./weaviate.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $when from "../../../altar/altar/when.mjs";
import * as $weaviate from "../../../data_types/data/weaviate.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function create_collection(org_id, kind, variant) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Nabu(),
            toList(["admin", "weaviate", "collections", "create"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(
              toList([
                ["org_id", $json.string(org_id)],
                ["kind", $json.string($weaviate.kind_to_string(kind))],
                ["variant", $json.string($weaviate.variant_to_string(variant))],
              ]),
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Collection created successfully",
              );
              dispatch(_pipe$4);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (e) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Failed to create collection: " + $string.inspect(e),
              );
              dispatch(_pipe$5);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_collections(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Nabu(),
            toList(["admin", "weaviate", "collections"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.query(_pipe$2, "org_id", org_id);
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.list($weaviate.collection_decoder()),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (collections) => {
              let _pipe$5 = new $msg.ApiReturnedCollections(org_id, collections);
              let _pipe$6 = new $msg.Weaviate(_pipe$5);
              dispatch(_pipe$6);
              return undefined;
            },
          );
          let _pipe$6 = $ask.on_error(
            _pipe$5,
            (e) => {
              let _pipe$6 = $string.inspect(e);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredCollections(org_id, _capture);
              })(_pipe$6);
              let _pipe$8 = new $msg.Weaviate(_pipe$7);
              dispatch(_pipe$8);
              return undefined;
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function fetch_migrations(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "weaviate-migration"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($weaviate.weaviate_migration_run_decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (migrations) => {
              let _pipe$4 = new $msg.ApiReturnedMigrations(org_id, migrations);
              let _pipe$5 = new $msg.Weaviate(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (e) => {
              let _pipe$5 = $string.inspect(e);
              let _pipe$6 = ((_capture) => {
                return new $msg.ApiErroredMigrations(org_id, _capture);
              })(_pipe$5);
              let _pipe$7 = new $msg.Weaviate(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function launch_migration(
  collection_kind,
  source_variant,
  target_variant,
  batch_size,
  sleep,
  dry_run,
  overwrite,
  previous_run_id
) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          return $when.some_(
            store.organization,
            () => { return $promise.resolve(undefined); },
            (org_id) => {
              let _pipe = $ask.to(
                new $ask.Admin(),
                toList(["organizations", org_id, "weaviate-migration"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Post());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.with$(
                _pipe$2,
                $json.object(
                  toList([
                    ["org_id", $json.string(org_id)],
                    [
                      "collection_kind",
                      $json.string($weaviate.kind_to_string(collection_kind)),
                    ],
                    [
                      "source_variant",
                      $weaviate.encode_collection_variant(source_variant),
                    ],
                    [
                      "target_variant",
                      $weaviate.encode_collection_variant(target_variant),
                    ],
                    ["batch_size", $json.int(batch_size)],
                    ["sleep", $json.int(sleep)],
                    ["dry_run", $json.bool(dry_run)],
                    ["overwrite", $json.bool(overwrite)],
                    [
                      "previous_run_id",
                      $json.nullable(previous_run_id, $json.string),
                    ],
                  ]),
                ),
              );
              let _pipe$4 = $ask.on_success(
                _pipe$3,
                (_) => {
                  let _pipe$4 = new $msg.UserSubmittedMigration(org_id);
                  let _pipe$5 = new $msg.Weaviate(_pipe$4);
                  dispatch(_pipe$5);
                  return undefined;
                },
              );
              let _pipe$5 = $ask.run(_pipe$4);
              return $promise.map(_pipe$5, $function.constant(undefined));
            },
          );
        },
      );
    },
  );
}
